<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../event-bus'
import { store } from '@/store/store'
import sharedService from '../../utils/shared-service'
import toasterService from '../../utils/toaster'
import requestBody from '../../orchestration/authSDK/request-parameter'
import traceService from '../shared/trace/trace-service'
import { CONSTANT, MFA_METHODS, MFA_API_METHODS, FIDO_METHODS, SCOF_FLOW, AUTH_METHODS } from '../../utils/constant'
import { WebAuthn } from '../../orchestration/webAuthN/index'

export default {
  name: 'BindMfa',

  data () {
    return {
      CONSTANT: CONSTANT,
      SCOF_FLOW: SCOF_FLOW,
      mfaMethodInstanceId: '',
      externalMfaMethodInstanceId: '',
      enableUnbindButton: false,
      mfaEligibilityData: [],
      mfaEligibilityIndex: 0,
      error: '',
      selectedMfaEligibilityId: '',
      trackBindUnbind: [],
      saveCard: false,
      isExistingUser: false,
      selectedMethod: '',
      webAuthNInstance: null,
      enablePayloadButton: false,
      authReason: '',
      keyName: 'mfaMethodInstanceId',
      hideContinueButtonForIAB: false,
      pkiKeyId: null
    }
  },

  computed: {
    ...mapGetters([
      'enrollMaskCard',
      'srcNetwork',
      'consumerJwt',
      'authResponse',
      'consumerInfo',
      'consumerContactInfo',
      'scofExecutionFlow',
      'attestationId',
      'pkiAttestationKeyId',
      'selectedSavedCardDetails',
      'merchantSavedCards',
      'scofDpaId',
      'tavInfo',
      'deviceExternalMfaMethodInstanceId',
      'selectedBindingDetails',
      'isIABFlow',
      'enableB2bAuthenticate'
    ]),

    isVisible () {
      if (this.scofExecutionFlow === SCOF_FLOW.TAV || this.scofExecutionFlow === SCOF_FLOW['MDES_IDV']) {
        return true
      }
      return this.selectedMethod === SCOF_FLOW['3DS']
    },

    isThirdPartyFIDOEnabled: {
      get () {
        return this.$store.getters.thirdPartyFIDO
      },
      set (value) {
        this.$store.commit('setThirdPartyFIDO', value)
      }
    },

    isThirdPartyPKIEnabled: {
      get () {
        return this.$store.getters.thirdPartyPKI
      },
      set (value) {
        this.$store.commit('setThirdPartyPKI', value)
      }
    }
  },
  created () {
    this.selectedBindingDetails ? this.renderComponentForCheckoutWithBindingIds() : this.renderComponentForOtherCase()
    const { userId: id, email: name, firstName, lastName } = this.consumerInfo
    const displayName = `${firstName} ${lastName}`
    if (this.webAuthNInstance === null) {
      this.webAuthNInstance = new WebAuthn(
        {
          id: id,
          name: name,
          displayName: displayName
        },
        "START's 3rd Party FIDO Testing"
      )
    }
  },
  mounted () {
    EventBus.$on('updateSaveCard', (event) => {
      this.saveCard = event
    })
    this.selectedMfaEligibilityData()
    this.updateMFAId(0)
    EventBus.$emit('enableSaveCardCheckbox', !this.isExistingUser)
  },

  methods: {
    renderComponentForCheckoutWithBindingIds () {
      this.enablePayloadButton = true
      this.isExistingUser = true
      this.selectedMfaEligibilityId = this.selectedBindingDetails.certifiedMfaMethodId
      if (this.selectedBindingDetails.mfaMethodInstanceId) {
        this.mfaMethodInstanceId = this.selectedBindingDetails.mfaMethodInstanceId
        this.keyName = 'mfaMethodInstanceId'
      } else {
        this.externalMfaMethodInstanceId = this.selectedBindingDetails.externalMfaMethodInstanceId
        this.keyName = 'externalMfaMethodInstanceId'
      }
    },

    renderComponentForOtherCase () {
      if (this.scofExecutionFlow !== SCOF_FLOW.TAV || this.scofExecutionFlow !== SCOF_FLOW.TXAV) {
        this.isExistingUser = this.authResponse ? this.authResponse.isExistingCard : (!!this.selectedSavedCardDetails)
        this.selectedMethod = this.authResponse ? this.authResponse.selectedMethod : ''
        this.authReason = this.authResponse ? this.authResponse.authReason : ''
      }
      this.setPayloadButtonState()
    },
    setPayloadButtonState () {
      if (this.isExistingUser || this.selectedMethod === 'MANAGED_AUTHENTICATION' || this.scofExecutionFlow === SCOF_FLOW.TXAV) {
        this.enablePayloadButton = true
      }
      if (this.isThirdPartyFIDOEnabled && this.deviceExternalMfaMethodInstanceId !== null) {
        this.enablePayloadButton = true
      }
    },

    async initiateMFABinding () {
      let maskedCardData = this.enrollMaskCard.serviceId ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard
      if (this.isThirdPartyPKIEnabled) {
        try {
          this.$store.commit('loaderOn', true)
          const response = await sharedService.getThirdPartyPKIData(requestBody[MFA_METHODS.THIRD_PARTY_PKI_ATTESTATION](maskedCardData))
          traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
          this.pkiKeyId = response?.pkiResponse?.keyId
          this.bindMFAForThirdPartyPki(response?.pkiResponse, maskedCardData)
        } catch (error) {
          this.$store.commit('loaderOn', false)
          let errorLog = error.response.data.callTraces
          traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        }
      } else {
        this.bindMFA()
      }
    },

    async bindMFAForThirdPartyPki (attestation, maskedCardData) {
      try {
        const requestParam = requestBody[MFA_METHODS.BIND_THIRD_PARTY_PKI](this.selectedMfaEligibilityId, maskedCardData, attestation, false)
        let response = await sharedService.getBindMfaApiResponse(
          requestParam,
          MFA_API_METHODS.BIND
        )
        toasterService.onSuccess(this.$t('successMessages.BIND_MFA_SUCCESS'))
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        this.trackBindUnbind.push(this.selectedMfaEligibilityId)
        if (response) {
          this.externalMfaMethodInstanceId = response.bindMfaResponse.externalCredentialId
          this.mfaMethodInstanceId = response.bindMfaResponse.credentialId
          const bindingDetails = {
            externalMfaMethodInstanceId: this.externalMfaMethodInstanceId,
            mfaMethodInstanceId: this.mfaMethodInstanceId
          }
          this.$store.dispatch('updateConsumerDeviceData', { fidoData: attestation, bindingDetails })
          this.enableUnbindButton = true
          this.enablePayloadButton = true
          this.updateMerchantCardBindingDetails(maskedCardData.srcDigitalCardId, this.selectedMfaEligibilityId, this.mfaMethodInstanceId, this.externalMfaMethodInstanceId)
        }
        this.$store.commit('loaderOn', false)
      } catch (err) {
        this.$store.commit('loaderOn', false)
        this.enableUnbindButton = false
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('BIND_MFA_FAILED')
      }
    },

    async bindMFA () {
      if (this.trackBindUnbind.indexOf(this.selectedMfaEligibilityId) > -1) {
        this.enableUnbindButton = false
        this.error = this.$t('ALREADY_BIND_MFA_MESSAGE')
        return
      }

      let maskedCardData = this.enrollMaskCard.serviceId ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard

      let fidoData = null
      if (this.isThirdPartyFIDOEnabled) {
        fidoData = this.isAttestationAvailable() ? await this.generate3PFidoAssertion() : await this.generate3PFidoAttestation()
        if (fidoData === null || !fidoData) {
          return
        }
      }

      try {
        this.$store.commit('loaderOn', true)
        this.error = ''
        this.$store.commit('setConsumerContactInfo', '')

        let response = await sharedService.getBindMfaApiResponse(
          requestBody[MFA_METHODS.BIND](this.selectedMfaEligibilityId, maskedCardData, fidoData, this.isAttestationAvailable()),
          MFA_API_METHODS.BIND
        )
        toasterService.onSuccess(this.$t('successMessages.BIND_MFA_SUCCESS'))
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        this.trackBindUnbind.push(this.selectedMfaEligibilityId)
        if (response) {
          this.externalMfaMethodInstanceId = response.bindMfaResponse.externalMfaMethodInstanceId
          this.mfaMethodInstanceId = response.bindMfaResponse.mfaMethodInstanceId
          const bindingDetails = {
            externalMfaMethodInstanceId: this.externalMfaMethodInstanceId,
            mfaMethodInstanceId: this.mfaMethodInstanceId
          }
          if (this.isThirdPartyFIDOEnabled) {
            this.$store.dispatch('updateConsumerDeviceData', { fidoData, bindingDetails })
          }
          this.enableUnbindButton = true
          this.enablePayloadButton = true
          this.updateMerchantCardBindingDetails(maskedCardData.srcDigitalCardId, this.selectedMfaEligibilityId, this.mfaMethodInstanceId, this.externalMfaMethodInstanceId)
        }
        this.$store.commit('loaderOn', false)
      } catch (err) {
        this.$store.commit('loaderOn', false)
        this.enableUnbindButton = false
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('BIND_MFA_FAILED')
      }
    },

    updateMerchantCardBindingDetails (srcDigitalCardId, certifiedMfaMethodId, mfaMethodInstanceId, externalMfaMethodInstanceId) {
      if (certifiedMfaMethodId === '' || mfaMethodInstanceId === '' || externalMfaMethodInstanceId === '') return
      const deviceId = localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)
      const cardExist = this.merchantSavedCards.some(card => card.scofMaskedCard.srcDigitalCardId === srcDigitalCardId)
      if (!cardExist) return
      const bindingDetails = { mfaMethodInstanceId, externalMfaMethodInstanceId }
      let savedCard = this.consumerInfo.merchantCardIds.find(card => card.scofMaskedCard.srcDigitalCardId === srcDigitalCardId)
      if (!savedCard.bindingIds) {
        savedCard.bindingIds = {}
      }
      if (!savedCard.bindingIds[deviceId]) {
        savedCard.bindingIds[deviceId] = {}
      }
      savedCard.bindingIds[deviceId][certifiedMfaMethodId] = savedCard.bindingIds[deviceId][certifiedMfaMethodId]
        ? [...savedCard.bindingIds[deviceId][certifiedMfaMethodId], bindingDetails]
        : [bindingDetails]
      this.$store.commit('changeConsumerInfo', this.consumerInfo)
    },

    isAttestationAvailable () {
      return this.consumerInfo.consumerDeviceData && this.consumerInfo.consumerDeviceData[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)]
    },

    async authenticateForTxav (maskCardData) {
      try {
        this.$store.commit('loaderOn', true)
        let authReqParams = requestBody[AUTH_METHODS.AUTHENTICATEFORTXAV](maskCardData)
        let authResponse = await sharedService.getB2BAuthenticateApiResponse(authReqParams)
        traceService.updateCallTraces(this.srcNetwork, authResponse.callTraces, true)
        this.$store.commit('loaderOn', false)
        toasterService.onSuccess(this.$t('successMessages.AUTHENTICATE_SUCCESS'))
        return authResponse
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('AUTHENTICATE_FAILED')
        throw new Error(err)
      }
    },

    async unbindMFA (key, additionalKey = null) {
      let {
        srcCorrelationId,
        maskedCard: { srcDigitalCardId, serviceId } = {}
      } = this.isExistingUser ? this.selectedSavedCardDetails : {}

      if (!this.isExistingUser) {
        ({ srcDigitalCardId, srcCorrelationId, serviceId } = this.enrollMaskCard)
      }

      let requestParam
      switch (key) {
        case 'mfaMethodInstanceId':
          requestParam = requestBody[MFA_METHODS.UNBIND](key, this.mfaMethodInstanceId, srcDigitalCardId, this.selectedMfaEligibilityId, serviceId, srcCorrelationId)
          break
        case 'externalMfaMethodInstanceId':
          requestParam = requestBody[MFA_METHODS.UNBIND](key, this.externalMfaMethodInstanceId, srcDigitalCardId, this.selectedMfaEligibilityId, serviceId, srcCorrelationId)
          break
        case 'resourceId':
          const params = additionalKey === 'externalMfaMethodInstanceId' ? this.externalMfaMethodInstanceId : this.mfaMethodInstanceId
          requestParam = requestBody[MFA_METHODS.UNBIND](key, params, srcDigitalCardId, this.selectedMfaEligibilityId, serviceId, srcCorrelationId, additionalKey)
          break

        default:
          requestParam = requestBody[MFA_METHODS.UNBIND](key, this.mfaMethodInstanceId, srcDigitalCardId, this.selectedMfaEligibilityId, serviceId, srcCorrelationId)
          break
      }
      try {
        this.$store.commit('loaderOn', true)
        this.error = ''
        let response = await sharedService.getBindMfaApiResponse(requestParam, MFA_API_METHODS.UNBIND)
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        toasterService.onSuccess(this.$t('successMessages.UNBIND_MFA_SUCCESS'))
        this.trackBindUnbind.pop(this.selectedMfaEligibilityId)
        this.$store.commit('loaderOn', false)
        this.enableUnbindButton = false
        this.clearBindingInfo(srcDigitalCardId)
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('UNBIND_MFA_FAILED')
      }
    },

    clearBindingInfo (srcDigitalCardId) {
      const deviceId = localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)
      let { consumerDeviceData, merchantCardIds } = this.consumerInfo

      if ((consumerDeviceData && consumerDeviceData[deviceId]) && this.isThirdPartyFIDOEnabled) {
        delete consumerDeviceData[deviceId]
      }
      if (merchantCardIds) {
        let selectedCard = merchantCardIds.find(card => card.scofMaskedCard.srcDigitalCardId === srcDigitalCardId)
        const certifiedMfaId = selectedCard.bindingIds[deviceId]
        if (certifiedMfaId && Object.keys(certifiedMfaId).length === 1) {
          selectedCard.bindingIds = {}
        } else {
          delete certifiedMfaId[this.selectedMfaEligibilityId]
        }
      }
      this.$store.commit('changeConsumerInfo', this.consumerInfo)
      this.selectedMfaEligibilityId = ''
      this.mfaMethodInstanceId = ''
      this.externalMfaMethodInstanceId = ''
    },

    async saveCardDetail () {
      let isCardExist = this.merchantSavedCards.filter(card => card.scofMaskedCard.panLastFour === this.enrollMaskCard.panLastFour)
      if (isCardExist.length > 0) {
        toasterService.onFailure(this.$t('errorMessages.CARD_ALREADY_PRESENT'))
        this.saveCard = false
        EventBus.$emit('enableSaveCardCheckbox', false)
      } else {
        try {
          let saveCardResponse = await sharedService.getScofPayloadApiResponse(requestBody[FIDO_METHODS.SAVE_CARD](this.consumerJwt, this.enrollMaskCard, this.selectedMfaEligibilityId, this.mfaMethodInstanceId, this.externalMfaMethodInstanceId))
          if (saveCardResponse) {
            const merchantCardIds = this.consumerInfo.merchantCardIds
            if (merchantCardIds === null) {
              this.consumerInfo.merchantCardIds = []
            }
            const cardDetails = {
              srcEnvironment: store.getters.environment,
              region: store.getters.region,
              scofMaskedCard: this.enrollMaskCard,
              cardbrand: 'MASTERCARD',
              srcDpaId: this.scofDpaId,
              bindingIds: null,
              srcCorrelationId: this.enrollMaskCard.srcCorrelationId
            }
            this.consumerInfo.merchantCardIds.push(cardDetails)
            toasterService.onSuccess(this.$t('successMessages.SAVE_CARD_SUCCESS'))
            this.hideContinueButtonForIAB = true
            this.$store.commit('changeConsumerInfo', this.consumerInfo)
            this.updateMerchantCardBindingDetails(this.enrollMaskCard.srcDigitalCardId, this.selectedMfaEligibilityId, this.mfaMethodInstanceId, this.externalMfaMethodInstanceId)
            EventBus.$emit('enableSaveCardCheckbox', false)
            this.saveCard = false
          }
        } catch (err) {
          let errorLog = err.response.data.callTraces
          traceService.updateCallTraces(this.srcNetwork, errorLog, true)
          this.error = this.$t('SAVE_CARD_ERROR')
        }
      }
    },

    async scofPayload () {
      this.error = ''
      if (this.saveCard) {
        await this.saveCardDetail()
        if (this.isIABFlow) return
      }
      if (this.selectedMethod === 'MANAGED_AUTHENTICATION' && this.authReason === 'ENROL_FINANCIAL_INSTRUMENT') {
        this.$store.commit('setConsumerContactInfo', '')
        this.$store.commit('setConsumerContactInfo', this.consumerInfo.email)
        EventBus.$emit('enableSaveCardCheckbox', false)
        return
      }
      await this.executePayload()

      if (this.consumerContactInfo !== '') {
        this.$store.dispatch('decrement')
      }
    },

    // eslint-disable-next-line complexity
    async getAuthToken (assertion, isPKIAssertion) {
      let maskedCardData = this.enrollMaskCard.serviceId ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard
      let bindInstanceId
      if (this.selectedBindingDetails) {
        bindInstanceId = this.selectedBindingDetails.mfaMethodInstanceId ? this.selectedBindingDetails.mfaMethodInstanceId : this.selectedBindingDetails.externalMfaMethodInstanceId
      } else {
        bindInstanceId = isPKIAssertion ? this.mfaMethodInstanceId : this.externalMfaMethodInstanceId
        this.keyName = 'externalMfaMethodInstanceId'
      }
      const srcCorrelationId = this.isExistingUser ? this.selectedSavedCardDetails.srcCorrelationId : maskedCardData.srcCorrelationId
      let reqParams = requestBody[AUTH_METHODS.B2B_AUTHENTICATE_ASSERTION](
        srcCorrelationId,
        maskedCardData.srcDigitalCardId,
        maskedCardData.serviceId,
        assertion,
        this.selectedMfaEligibilityId,
        bindInstanceId,
        this.keyName,
        isPKIAssertion
      )
      try {
        let response = await sharedService.getB2BAuthenticateApiResponse(reqParams)
        traceService.updateCallTraces('mastercard', response.callTraces, true)
        if (response && response.authenticateResponse) {
          if (response.authenticateResponse.authenticationStatus === 'COMPLETE' && response.authenticateResponse.authenticationResult === 'AUTHENTICATED') {
            return response.authenticateResponse.assuranceData
          }
        } else {
          toasterService.onFailure(this.$t('errorMessages.AUTHENTICATE_FAILED'))
          return null
        }
      } catch (err) {
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces('mastercard', errorLog, false)
        this.$store.commit('loaderOn', false)
        this.error = err.response.data.message
        throw new Error(err)
      }
    },

    async getAssuranceData (maskedCardData) {
      let assuranceData
      if (this.scofExecutionFlow === SCOF_FLOW.TXAV) {
        let response = await this.authenticateForTxav(maskedCardData).catch(err => {
          throw err
        })
        assuranceData = response.authenticateResponse.assuranceData
      }

      if (sharedService.checkFeatureFlag('START_FA2_CHANGES') && this.enableB2bAuthenticate && !this.isThirdPartyFIDOEnabled && this.selectedMethod !== 'MANAGED_AUTHENTICATION') {
        let response = await this.authenticateForProprietary(maskedCardData).catch(err => {
          throw err
        })
        assuranceData = response.authenticateResponse.assuranceData
      }

      if (this.isThirdPartyFIDOEnabled) {
        const assertion = await this.generate3PFidoAssertion()
        assuranceData = await this.getAuthToken(assertion, false).catch(err => {
          this.$store.commit('loaderOn', false)
          console.log(err)
          throw err
        })
      }
      if (this.isThirdPartyPKIEnabled) {
        try {
          const keyId = this.selectedBindingDetails ? this.pkiAttestationKeyId : this.pkiKeyId
          const assertionResponse = await sharedService.getThirdPartyPKIData(requestBody[MFA_METHODS.THIRD_PARTY_PKI_ASSERTION](maskedCardData, keyId))
          const assertion = Object.assign({}, assertionResponse?.pkiResponse)
          delete assertion?.appInstanceGuid
          delete assertion?.keyId
          delete assertion?.attestationObject
          traceService.updateCallTraces(this.srcNetwork, assertionResponse.callTraces, true)
          assuranceData = await this.getAuthToken(assertion, true).catch(err => {
            this.$store.commit('loaderOn', false)
            console.log(err)
          })
        } catch (err) {
          this.$store.commit('loaderOn', false)
          let errorLog = err.response.data.callTraces
          traceService.updateCallTraces(this.srcNetwork, errorLog, true)
          this.error = this.$t('PKI_ASSERTION_FAILED')
        }
      }
      return assuranceData
    },

    async executePayload () {
      try {
        this.$store.commit('loaderOn', true)
        let maskedCardData = this.enrollMaskCard.serviceId ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard
        this.$store.commit('setConsumerContactInfo', '')
        const assuranceData = await this.getAssuranceData(maskedCardData)
        let bindInstanceId
        if (this.selectedBindingDetails) {
          bindInstanceId = this.selectedBindingDetails.mfaMethodInstanceId ? this.selectedBindingDetails.mfaMethodInstanceId : this.selectedBindingDetails.externalMfaMethodInstanceId
        } else {
          bindInstanceId = this.mfaMethodInstanceId
        }
        const correlationId = this.isExistingUser ? this.selectedSavedCardDetails.srcCorrelationId : null
        let response = await sharedService.getScofPayloadApiResponse(requestBody[MFA_METHODS.PAYLOAD](this.selectedMfaEligibilityId, bindInstanceId, maskedCardData, assuranceData, correlationId, this.keyName))
        let consumerContactInfo = response.decryptedCheckoutResponse.checkoutResponseJWSPayload.maskedConsumer.maskedConsumerIdentity.maskedIdentityValue
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        toasterService.onSuccess(this.$t('successMessages.PAYLOAD_SUCCESS'))
        this.$store.commit('setConsumerContactInfo', consumerContactInfo)
        EventBus.$emit('enableSaveCardCheckbox', false)
        this.$store.commit('loaderOn', false)
      } catch (err) {
        console.log(err)
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('PAYLOAD_ERROR')
      }
    },

    async generate3PFidoAssertion () {
      const response = await this.webAuthNInstance.authenticateCredential(this.attestationId).catch((e) => {
        this.error = 'THIRD_PARTY_FIDO_ERROR'
      })
      return response
    },

    selectedMfaEligibilityData () {
      let mfaData = this.enrollMaskCard.mfaEligibility ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard
      if (mfaData && !mfaData.mfaEligibility) {
        return
      }
      this.mfaEligibilityData = mfaData.mfaEligibility.map(
        (item) => {
          if (
            item.isMultiFactorAuthenticationSupported &&
            item.isLiabilityShiftEligible
          ) {
            return {
              displayName: `MFA_FLS_${item.certifiedMfaMethodId}`,
              ...item
            }
          } else if (
            !item.isMultiFactorAuthenticationSupported &&
            !item.isLiabilityShiftEligible
          ) {
            return {
              displayName: `NoMFA_NoFLS_${item.certifiedMfaMethodId}`,
              ...item
            }
          } else if (
            !item.isMultiFactorAuthenticationSupported &&
            item.isLiabilityShiftEligible
          ) {
            return {
              displayName: `NoMFA_FLS_${item.certifiedMfaMethodId}`,
              ...item
            }
          } else if (
            item.isMultiFactorAuthenticationSupported &&
            !item.isLiabilityShiftEligible
          ) {
            return {
              displayName: `MFA_NoFLS_${item.certifiedMfaMethodId}`,
              ...item
            }
          }
        }
      )
      this.mfaEligibilityData.sort(
        (a, b) =>
          Number(b.isMultiFactorAuthenticationSupported) -
            Number(a.isMultiFactorAuthenticationSupported)
      )
    },

    updateMFAId (mfaEligibilityIndex) {
      if (this.mfaEligibilityData.length === 0) {
        return
      }
      if (!this.selectedBindingDetails) {
        this.selectedMfaEligibilityId =
        this.mfaEligibilityData[mfaEligibilityIndex].certifiedMfaMethodId
        if (this.trackBindUnbind.length > 0 && this.trackBindUnbind.indexOf(this.selectedMfaEligibilityId) > -1) {
          this.enableUnbindButton = true
        } else {
          this.enableUnbindButton = false
        }
      }
    },

    async generate3PFidoAttestation () {
      const response = await this.webAuthNInstance
        .createCredential()
        .catch((e) => {
          this.error = 'THIRD_PARTY_FIDO_ERROR'
          Promise.reject(e)
        })
      if (response) {
        return response
      }
    },

    /**
     * call method to return auth token
     * @param maskCardData
     */
    async authenticateForProprietary (maskCardData) {
      try {
        this.$store.commit('loaderOn', true)
        let authReqParams = requestBody[AUTH_METHODS.AUTHENTICATEFORPROPRIETARY](maskCardData, this.selectedMfaEligibilityId, this.mfaMethodInstanceId, this.keyName)
        let authResponse = await sharedService.getB2BAuthenticateApiResponse(authReqParams)
        traceService.updateCallTraces(this.srcNetwork, authResponse.callTraces, true)
        this.$store.commit('loaderOn', false)
        toasterService.onSuccess(this.$t('successMessages.AUTHENTICATE_SUCCESS'))
        return authResponse
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('AUTHENTICATE_FAILED')
        throw new Error(err)
      }
    }
  }
}
</script>

<template>
  <div class="card-input-wrapper">
    <div v-if="!isIABFlow">
      <div
        v-if="error"
        class="alert alert-danger"
        role="alert">
        {{ $t("errorMessages." + error) }}
      </div>
      <div
        v-if="isVisible"
        id="mfa-eligibility"
        class="form-group"
        data-test="mfa-eligibility-ID-container"
      >
        <label>{{ $t("label.mfaEligibilityLable") }}</label>
        <select
          id="select-mfa-eligibility-ID"
          v-model="mfaEligibilityIndex"
          class="option-dpa form-control"
          data-test="select-mfa-eligibility-ID"
          @change="updateMFAId(mfaEligibilityIndex)"
        >
          <option
            v-for="(entity, index) in mfaEligibilityData"
            :key="entity.displayName"
            :value="index"
          >
            {{ entity.displayName }}
          </option>
        </select>
      </div>
      <button
        v-if="isVisible"
        id="bind-button"
        class="btn btn-primary btn-lg mt-3 px-4"
        data-test="btn-continue"
        type="submit"
        @click="initiateMFABinding()"
      >
        {{ $t("label.bindMFALable") }}
      </button>
      <div
        v-if="isVisible"
        class="dropdown d-inline">
        <button
          id="unbindDropdownMenuButton"
          :disabled="!enableUnbindButton"
          class="btn btn-primary btn-lg mt-3 px-4 mx-3 dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          {{ $t("label.unbindMFALable") }}
        </button>
        <div
          class="dropdown-menu cursor-pointer"
          aria-labelledby="unbindDropdownMenuButton">
          <a
            class="dropdown-item cursor-pointer"
            @click="unbindMFA('mfaMethodInstanceId')">{{ $t("label.unbindMFALable1") }}</a>
          <a
            class="dropdown-item cursor-pointer"
            @click="unbindMFA('externalMfaMethodInstanceId')">{{ $t("label.unbindMFALable2") }}</a>
          <a
            class="dropdown-item cursor-pointer"
            @click="unbindMFA('resourceId','mfaMethodInstanceId')">{{ $t("label.unbindMFALable4") }}</a>
          <a
            class="dropdown-item cursor-pointer"
            @click="unbindMFA('resourceId','externalMfaMethodInstanceId')">{{ $t("label.unbindMFALable5") }}</a>
          <a
            class="dropdown-item cursor-pointer"
            @click="unbindMFA('resourceId')">{{ $t("label.unbindMFALable3") }}</a>
        </div>
      </div>
    </div>
    <button
      v-if="!isIABFlow || (isIABFlow && !hideContinueButtonForIAB)"
      id="continue-button"
      :disabled="!enablePayloadButton && !isIABFlow"
      class="btn btn-primary btn-lg mt-3 px-4"
      data-test="btn-continue"
      type="submit"
      @click="scofPayload()"
    >
      {{ $t("label.continueLabel") }}
    </button>
  </div>
</template>
